<template>
  <div class="app-container">
    查看报名
    <el-table :data="tableData" border>
      <el-table-column prop="date" label="序号" min-width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="报名队伍" min-width="120" align="center">
        <template slot-scope="scope">
          {{ JSON.parse(scope.row.team_snap).name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="报名时间"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          {{ JSON.parse(scope.row.team_snap).updated_at }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="address"
        label="净胜分"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.net_points }}
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      list: [],
      listQuery: {
        page: 1,
        limit: 10,
        match_id: null,
      },
      tableData: [],
    };
  },
  created() {
    this.listQuery.match_id = this.$route.query.id;
    this.listQuery.match_system_id = this.$route.query.match_system_id;
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/schoolend/match/rankingList",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.tableData = response.data;
        this.listLoading = false;
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
